import { render, staticRenderFns } from "./AssessmentImage.vue?vue&type=template&id=22b3ac8b&scoped=true"
import script from "./AssessmentImage.vue?vue&type=script&lang=js"
export * from "./AssessmentImage.vue?vue&type=script&lang=js"
import style0 from "./AssessmentImage.vue?vue&type=style&index=0&id=22b3ac8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b3ac8b",
  null
  
)

export default component.exports